import { observable, makeObservable } from 'mobx';

import type { Nullable, Optional } from 'chaika-common-types';
import { EntryTypeFieldType } from 'chaika-enums';

import { FieldData } from '@template/store/entryType/EntryTypeField';

export interface FieldParams {
    type: EntryTypeFieldType;
    data: Nullable<FieldData>;
    title: Optional<string>;
    global: boolean;
}

export class Common {
    public static Name = 'common' as const;

    @observable
    public fieldsParams: Map<string, FieldParams> = new Map();

    constructor() {
        makeObservable(this);
    }
}

export const common = new Common();
